import { useState, useEffect } from "react"
import { graphql, useStaticQuery } from "gatsby"


function useLinks() {
  const [linkMap,setLinkMap] = useState({})
  const results = useStaticQuery(graphql`
    query MyQuery {
      allStoryblokLink(filter: {is_folder: {eq: false}}) {
        edges {
          node {
            uuid
            id
            slug
            path
            real_path
            published
            name
            is_startpage
            is_folder
          }
        }
      }
    }
  `)

  useEffect(()=>{
    const newMap = {}

    results.allStoryblokLink.edges.forEach((edge)=>{
      let record = {
        uuid: edge.node.uuid,
        id: edge.node.id,
        slug: edge.node.slug,
        path: edge.node.path,
        real_path: edge.node.real_path,
        published: edge.node.published,
        name: edge.node.name,
        is_startpage: edge.node.is_startpage,
        is_folder: edge.node.is_folder
      }
      newMap[edge.node.uuid] = record
    })
    
    setLinkMap(newMap)
  },[])
  
  
  return linkMap
}

export default useLinks